import { render, staticRenderFns } from "./PHPDevelopment.vue?vue&type=template&id=9d615f52&"
import script from "./PHPDevelopment.vue?vue&type=script&lang=js&"
export * from "./PHPDevelopment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports